import { pageRoute, type PageRouteValue } from 'shared/constants/routes.constants'

export const normalizePathname = (pathname: string) => {
  const pathnameWithoutQuery = pathname.split(/[?#]/)[0] ?? ''
  const pathnameWithoutTrailingSlash = pathnameWithoutQuery.replace(/\/+$/, '')

  return pathnameWithoutTrailingSlash || pageRoute.Dashboard
}

const isDynamicRouteSegment = (segment: string) => segment.startsWith('[') && segment.endsWith(']')

export const routeMatchesPathname = (route: PageRouteValue, pathname: string) => {
  const routeSegments = normalizePathname(route).split('/').filter(Boolean)
  const pathnameSegments = normalizePathname(pathname).split('/').filter(Boolean)

  if (routeSegments.length !== pathnameSegments.length) return false

  return routeSegments.every(
    (routeSegment, index) =>
      isDynamicRouteSegment(routeSegment) || routeSegment === pathnameSegments[index],
  )
}

export const getMatchingPageRoute = (pathname: string): PageRouteValue | undefined => {
  const normalizedPathname = normalizePathname(pathname)
  const routes: PageRouteValue[] = Object.values(pageRoute)
  return (
    routes.find(route => normalizePathname(route) === normalizedPathname) ??
    routes.find(route => routeMatchesPathname(route, normalizedPathname))
  )
}

export const getPageRoutePattern = (pathname: string) =>
  getMatchingPageRoute(pathname) ?? normalizePathname(pathname)
